import React from 'react';
import { DiceViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: DiceViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
